/* eslint-disable no-dupe-keys */
export default {
  parking_relief_record: {
    name: '停车减免记录',
    // 属性（一般与对象内容匹配）
    prop: {
      plate_number: '车牌',
      user_name: '扫码微信用户',
      order_user: '订单用户',
      user_id: '订单用户',
      ip: '来源IP',
      user_from: '用户来源',
      ev_charging_station: '充电站',
      relief_type: '减免方式',
      order: '订单',
      relief_result: '减免结果',
      description: '描述',
      created_at: '领取优惠时间',
      updated_at: '更新时间',
      order_trade_number: '订单编号',
      wechat_user_info_nickname: '扫码用户'
    },
    // Enum的属性
    relief_types: {
      auto_relief: 'API减免',
      manual_relief: '人工领取'
    },
    relief_results: {
      succeed: '已减免',
      no_action: '未减免',
      unknown: '未知'
    },
    // Boolean的属性
    // 占位提示
    // 详情页标签
    // 标题
    labels: {
      latest_auto_relief_count: 'API减免数',
      latest_manual_relief_count: '人工领取数',
      latest_succeed_count: '已减免数',
      latest_no_action_count: '未减免数',
      latest_unknown_count: '结果未知的数量'
    }
  }
}
